var Analytics = function () {

};

var ATTRIBUTOR_NOT_SET = '(not set)';

/**
 * Display labels for Formie slice fields only (raw Attributor values are unchanged for pick rules + JSON blob).
 * Keys must match Attributor output exactly. Customize per project.
 */
var ATTRIBUTOR_LABEL_MAPS = {
	source: {
		'(direct)': 'Website',
		bing: 'Bing',
		duckduckgo: 'DuckDuckGo',
		google: 'Google',
		meta: 'Meta',
	},
	medium: {
		'(none)': 'Direct',
		cpc: 'Paid Search',
		display: 'Display',
		lead: 'Paid Social',
		organic: 'Organic Search',
		paid: 'Paid Search',
		ppc: 'Paid Search',
		referral: 'Referral',
		search: 'Paid Search',
	},
	campaign: {},
};

/** Lead source ID in Entrata; keys match labeled source–medium (see labeledSourceMediumFromTouch). */
var ENTRATA_DEFAULT_SOURCE_MEDIUM_ID = '75702';
var ENTRATA_SOURCE_MEDIUM_ID_MAP = {
	'Google - Organic Search': '91858',
	'Google - Paid Search': '91859',
	'Meta - Paid Search': '91860',
	'Meta - Paid Social': '91860',
	'ig - PaidSocial': '91860'
};

function mapAttributorLabel(map, raw) {
	if (raw == null || raw === '')
		return '';
	var s = String(raw);
	if (Object.prototype.hasOwnProperty.call(map, s))
		return map[s];
	return s;
}

function labeledSourceMediumFromTouch(touch) {
	var src = mapAttributorLabel(ATTRIBUTOR_LABEL_MAPS.source, touch.source);
	var med = mapAttributorLabel(ATTRIBUTOR_LABEL_MAPS.medium, touch.medium);
	if (!src && !med)
		return '';
	if (!src)
		return med;
	if (!med)
		return src;
	return src + ' - ' + med;
}

function entrataSourceMediumIdFromTouch(touch) {
	var key = labeledSourceMediumFromTouch(touch);
	if (!key || !Object.prototype.hasOwnProperty.call(ENTRATA_SOURCE_MEDIUM_ID_MAP, key))
		return ENTRATA_DEFAULT_SOURCE_MEDIUM_ID;
	return ENTRATA_SOURCE_MEDIUM_ID_MAP[key];
}

/**
 * Prefer first touch unless first lacks campaign signal and last shows paid/named activity.
 * Refine isWeakFirst / isStrongLast as marketing rules solidify.
 */
function isWeakFirstTouch(touch) {
	if (!touch)
		return true;
	var direct = touch.source === '(direct)' && touch.medium === '(none)';
	var noCampaign = !touch.campaign || touch.campaign === ATTRIBUTOR_NOT_SET;
	if (direct)
		return true;
	if (noCampaign)
		return true;
	return false;
}

var STRONG_LAST_MEDIA = {
	cpc: true,
	search: true,
	lead: true,
	paid: true,
	ppc: true,
	display: true,
};

function isStrongLastTouch(touch, data) {
	if (!touch)
		return false;
	if (touch.campaign && touch.campaign !== ATTRIBUTOR_NOT_SET)
		return true;
	var medium = (touch.medium || '').toLowerCase();
	if (STRONG_LAST_MEDIA[medium])
		return true;
	if (data.gclid)
		return true;
	return false;
}

function pickAttributionTouch(data) {
	var session = data.session || {};
	var first = session.first;
	var last = session.last;
	if (!first && !last)
		return {};
	if (!first)
		return last;
	if (!last)
		return first;
	if (isWeakFirstTouch(first) && isStrongLastTouch(last, data))
		return last;
	return first;
}

var ATTRIBUTOR_SLICE_FIELDS = [
	{ handle: 'attributorSource', key: 'source' },
	{ handle: 'attributorMedium', key: 'medium' },
	{
		handle: 'attributorSourceMedium',
		valueFromTouch: function (touch) {
			return labeledSourceMediumFromTouch(touch);
		},
	},
	{
		handle: 'attributorEntrataSourceMediumId',
		valueFromTouch: function (touch) {
			return entrataSourceMediumIdFromTouch(touch);
		},
	},
	{ handle: 'attributorCampaign', key: 'campaign' },
];

Analytics.prototype.init = function () {

	var self = this;

	if (typeof Attributor !== 'undefined') {

		self.attributor = new Attributor({
			cookieDomain: window.location.hostname,
			fieldMap: {
				cookies: {
					_ga: 'ga_client_id',
					_gcl_aw: 'gclid'
				}
			}
		});

		self.attributorData = self.attributor.grab();

		$(`.fui-form`).each(function () {

			let $form = $(this);
			let $attributorField = $form.find(`input[name="fields[attributorData]"]`);
			var hasSliceField = ATTRIBUTOR_SLICE_FIELDS.some(function (f) {
				return $form.find(`input[name="fields[${f.handle}]"]`).length;
			});

			if (!$attributorField.length && !hasSliceField)
				return;

			$form.on('onAfterFormieValidate', function (e) {
				var data = self.attributor.grab();
				self.attributorData = data;

				if ($attributorField.length)
					$attributorField.val(JSON.stringify(data));

				var touch = pickAttributionTouch(data);
				ATTRIBUTOR_SLICE_FIELDS.forEach(function (f) {
					var $input = $form.find(`input[name="fields[${f.handle}]"]`);
					if (!$input.length)
						return;
					var display;
					if (typeof f.valueFromTouch === 'function')
						display = f.valueFromTouch(touch);
					else {
						var labelMap = ATTRIBUTOR_LABEL_MAPS[f.key] || {};
						display = mapAttributorLabel(labelMap, touch[f.key]);
					}
					$input.val(display);
				});
			});

		});

	}

};

export default Analytics;
